/**
 * A prompt group. Prompts (a.k.a. filters) are scoped to a group: the user
 * picks a group first, then the prompts available within it are fetched.
 *
 * Normalised across both backends:
 * - Playbook Marketplace API: PlaybookGroupResponse
 * - Projects API:             FlowGroup list response
 */
export interface GroupModel {
  objectIdentifier: string;
  name: string;
  description?: string;
  orderNumber?: number;
  flowGroupType?: FlowGroupType;
}

/**
 * Mirrors `Jylo.Toolkit.Constants.FlowGroupType`. Both backends serialise
 * this as a camelCase string via JsonStringEnumConverter.
 * (`bundle` was previously `combinedDocuments`; `individually` was
 * `individualDocuments` / `documentSets`.)
 */
export enum FlowGroupType {
  Bundle = "bundle",
  Individually = "individually",
  SpreadsheetRowAnalysis = "spreadsheetRowAnalysis",
}
